import React, { useState, cloneElement, useRef, useEffect } from "react"
import { cn } from "../../lib/utils"

export function TooltipProvider({ children }) {
  return children
}

export function Tooltip({ children }) {
  return children
}

export function TooltipTrigger({ children, asChild, onOpen, onClose, triggerRef, ...props }) {
  // Attach ref to the trigger
  if (asChild && React.isValidElement(children)) {
    return cloneElement(children, { ref: triggerRef, ...props })
  }
  return <span ref={triggerRef} {...props}>{children}</span>
}

export function TooltipContent({ className, children, triggerRect, open, setOpen, side = "top", ...props }) {
  const [style, setStyle] = useState({})

  useEffect(() => {
    if (open && triggerRect) {
      // Position above the trigger
      const spacing = 8 // px
      let top = triggerRect.top - spacing
      let left = triggerRect.left + triggerRect.width / 2
      setStyle({
        position: 'fixed',
        top: `${top}px`,
        left: `${left}px`,
        transform: 'translate(-50%, -100%)',
        zIndex: 99999,
      })
    }
  }, [open, triggerRect])

  if (!open) return null
  return (
    <div
      className={cn(
        "z-50 overflow-hidden rounded-md border bg-white px-3 py-1.5  text-popover-foreground shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        className,
      )}
      style={style}
      {...props}
    >
      {children}
    </div>
  )
}

// HOC to wrap TooltipTrigger and TooltipContent with state
export function TooltipWrapper({ children }) {
  const [open, setOpen] = useState(false)
  const [triggerRect, setTriggerRect] = useState(null)
  const triggerRef = useRef(null)
  let trigger = null
  let content = null

  React.Children.forEach(children, child => {
    if (!child) return
    if (child.type && child.type.name === 'TooltipTrigger') {
      trigger = cloneElement(child, {
        onMouseEnter: (e) => {
          setOpen(true)
          if (triggerRef.current) {
            setTriggerRect(triggerRef.current.getBoundingClientRect())
          }
        },
        onFocus: (e) => {
          setOpen(true)
          if (triggerRef.current) {
            setTriggerRect(triggerRef.current.getBoundingClientRect())
          }
        },
        onMouseLeave: () => setOpen(false),
        onBlur: () => setOpen(false),
        tabIndex: 0,
        triggerRef,
      })
    } else if (child.type && child.type.name === 'TooltipContent') {
      content = cloneElement(child, { open, setOpen, triggerRect })
    }
  })

  return (
    <>
      {trigger}
      {content}
    </>
  )
}
